module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-04-a9c6da9f83c969887a7c8897cdba159d.jpg";